import {
	patientEngagementFlowFeatureFlagEnabled,
	patientAssignmentFeatureFlagEnabled,
} from '@/globalConsts/featureFlags';

export type FeatureFlagName = keyof typeof FEATURE_FLAGS;

const FEATURE_FLAGS = {
	//ROLE_BASED: [{ roles: ['admin', 'user'] }], // Example of a feature flag that could be enabled for specific roles
	PATIENT_ENGAGEMENT_FLOW: patientEngagementFlowFeatureFlagEnabled, // Example of a feature flag that could be enabled or disabled
	PATIENT_ASSIGNMENT: patientAssignmentFeatureFlagEnabled,
};

export const isFeatureEnabled = (featureName: FeatureFlagName) => {
	const rules = FEATURE_FLAGS[featureName];
	// Check if the feature flag is of type boolean, if so return the value
	if (typeof rules === 'boolean') return rules;
	// TODO: If the feature flag is an array, check if the user has the required role
	return null;
};
